import { BrowserRouter as Router, Switch, Route, Redirect} from 'react-router-dom';
import EsriMap from '../EsriMap';
import { USDAHeader } from '../shared/Header/head';
import { ROUTE_PATHS } from './paths';
import { Help } from '../features/help-page';
import { Alert } from '../shared/alert/Alert';
import { useAddAlert, useCloseAlert,useUser } from '../store/actions';
import { useStoreContext } from '../store/context';
import { About } from '../features/about-page';
import { useCallback, useEffect, useState } from 'react';
import { FieldSampleParent, FieldSampleChild } from 'src/features/field-sample';
import { checkAdminRole, fieldSampleAreaEditor, genUser } from 'src/store/common';
import { Contacts } from '../features/contacts';
import { Tables } from 'src/features/tables';
import { ApiGen } from 'src/features/api-gen';
import { Powerbi } from 'src/features/powerbi';
import { ReportDetailTab } from 'src/features/powerbi/reports/ReportDetailTab';
import { Catalogs } from 'src/features/catalogs/Catalogs';
import { checkBannerOutage } from 'src/apis/getWeatherCalls';
import { AddFuelCatalog } from 'src/features/catalogs/modals/AddFuelCatalog';
import { DataProcess } from 'src/features/data-import/DataProcess';
import { Calculator } from 'src/shared/Calculator/Calculator';
import { DownloadTabs } from 'src/features/download/DownloadTabs';

export function Routes(){
  const [state, dispatch] = useStoreContext();
  const closeAlert = useCloseAlert(dispatch);
  const addAlert = useAddAlert(dispatch);

  const setUser = useUser(dispatch);
  const [alerts, setAlerts] = useState<any[]>(state.alerts);

  const [theWarning, setTheWarning] = useState<any>(null)
    useEffect(()=>{
       const filterWarnings = state.alerts?.filter((alert)=>alert.type==='warning');
       if(filterWarnings.length>0){
        setTheWarning(filterWarnings[0])
        state.alerts?.forEach((a)=>{
          if(a.type==='warning'){
            if(a.id!==filterWarnings[0].id){
              closeAlert(a.id)
            }
          }
        })
       }
      setAlerts(state.alerts)
    }, [setAlerts, state.alerts, closeAlert]);
  
    /* outageCallback is to make a call to see if data is missing*/
    const outageCallback = useCallback(()=>{
      (async()=>{
          try{
            const response: any = await checkBannerOutage(addAlert);
            response?.forEach((n: any) => {
              if (n.ingest_type === 'system' && n.msg_token?.length>1) {
                addAlert({
                  id: '',
                  message: n.msg_token,
                  type: 'warning',
                  icon: 'fa-exclamation-triangle',
                  clear: 'persist'

                })
              }
              if(n.ingest_type === 'system' && (!n.msg_token || n.msg_token?.length<=1)){
                closeAlert(theWarning?.id)
              }
            })
          }
          catch(error){
            console.log('error', error)
          }
      })();
    },[addAlert, closeAlert, theWarning?.id]);

  useEffect(()=>{
    outageCallback();

    const interval = setInterval(() => {
      outageCallback();
    }, 60000);
    return () => {
				if(interval){
					clearInterval(interval);
				}
			}
  },[outageCallback]);

  useEffect(()=>{
    if(localStorage.getItem('user')){
      const parsedSession = JSON.parse(localStorage.getItem('user')??'')
      setUser(parsedSession.userInfo)
    }
  },[ setUser]);

  const checkRoutes = (user: any, local: any) => {
    if (!user) {
      if (local) {
        const parsedSession = JSON.parse(local);

        setUser(parsedSession.userInfo);
        if(fieldSampleAreaEditor(parsedSession.userInfo)){
          return (
            <>
              <Route path={ROUTE_PATHS.field_samples}>
                <FieldSampleParent />
              </Route>
              <Route path={ROUTE_PATHS.area}>
                <FieldSampleParent />
              </Route>
              <Route path={ROUTE_PATHS.group}>
                <FieldSampleParent />
              </Route>
              <Route path={ROUTE_PATHS.sample}>
                <FieldSampleChild />
              </Route>
              <Route path={ROUTE_PATHS.contacts}>
                <Contacts/>
              </Route>
              <Route path={ROUTE_PATHS.data_process}>
                <DataProcess/>
              </Route>
            </>
          )
        }
        else if (genUser(parsedSession.userInfo)) {
          return (
            <>
              <Route path={ROUTE_PATHS.field_samples}>
                <FieldSampleParent />
              </Route>
              <Route path={ROUTE_PATHS.area}>
                <FieldSampleParent />
              </Route>
              <Route path={ROUTE_PATHS.group}>
                <FieldSampleParent />
              </Route>
              <Route path={ROUTE_PATHS.sample}>
                <FieldSampleChild />
              </Route>
              <Route path={ROUTE_PATHS.contacts}>
                <Contacts/>
              </Route>
            </>
          )
        }
        else {
          return (<Redirect to={ROUTE_PATHS.home} />)
        }
      }
      else {
        return (<Redirect to={ROUTE_PATHS.home} />)
      }
    }
    else {
      if(fieldSampleAreaEditor(user)){
        return (
          <>
            <Route path={ROUTE_PATHS.field_samples}>
              <FieldSampleParent />
            </Route>
              <Route path={ROUTE_PATHS.area}>
                <FieldSampleParent />
              </Route>
            <Route path={ROUTE_PATHS.group}>
              <FieldSampleParent />
            </Route>
            <Route path={ROUTE_PATHS.sample}>
              <FieldSampleChild />
            </Route>
            <Route path={ROUTE_PATHS.contacts}>
              <Contacts/>
            </Route>
            <Route path={ROUTE_PATHS.data_process}>
              <DataProcess/>
            </Route>
          </>
        )
      }
      else if (genUser(user)) {
        return (
          <>
            <Route path={ROUTE_PATHS.field_samples}>
              <FieldSampleParent />
            </Route>
            <Route path={ROUTE_PATHS.area}>
                <FieldSampleParent />
              </Route>
            <Route path={ROUTE_PATHS.group}>
              <FieldSampleParent />
            </Route>
            <Route path={ROUTE_PATHS.sample}>
              <FieldSampleChild />
            </Route>
            <Route path={ROUTE_PATHS.contacts}>
              <Contacts/>
            </Route>
          </>
        )
      }
      else {
        return (<Redirect to={ROUTE_PATHS.home} />)
      }
    }
  }

    return(
        <Router>
          <USDAHeader />
          <div id={'alerts'} style={{position: 'fixed', zIndex:10000, width: '100%'}}>
            {alerts.map((alert:any)=>(
              alert.type!=='warning'  &&
                (<Alert
                  type={alert.type}
                  icon={alert.icon}
                  key={alert.id}
                  onClose={()=>{closeAlert(alert.id);}}
                  keyDown={(event:any)=>event.key ==='Enter' && closeAlert(alert.id) }
                > 
                  {alert.message}
                </Alert>
                )
              ))}
            </div>
            {alerts?.filter((a)=>a.type==='warning')?.length>0 && 
              <div id={'warnings'} style={{ zIndex:100, width: '100%'}}>
            {alerts.map((alert:any)=>(
              alert.type==='warning'  &&
                (<Alert
                  type={alert.type}
                  icon={alert.icon}
                  key={alert.id}
                > 
                  {alert.message}
                </Alert>
                )
              ))}
            </div>
            }
            {
              state.openCalc && <Calculator/>
            }

            <Switch>
              <Route path={ROUTE_PATHS.home}>
                <EsriMap/>
              </Route> 
              <Route exact path="/" render={() => (
                <Redirect to={ROUTE_PATHS.home}/>
              )}>
              </Route>
              <Route
                path={ROUTE_PATHS.table}
              >
                  <Tables />
                </Route>
              <Route path={ROUTE_PATHS.help}>
                <Help/>
              </Route>
              <Route path={ROUTE_PATHS.inap}>   
                <EsriMap/>
              </Route>
              <Route path={ROUTE_PATHS.about}>   
                <About/>
              </Route>
              <Route path={ROUTE_PATHS.download}>   
                <DownloadTabs/>
              </Route>
              <Route path={ROUTE_PATHS.apiKey}>   
                  <ApiGen/>
              </Route>
              
              <Route path={ROUTE_PATHS.powerbi}>   
                  <Powerbi/>
              </Route>
              <Route path={ROUTE_PATHS.report}>   
                <ReportDetailTab/>
              </Route>
              <Route path={ROUTE_PATHS.catalogs}>   
                <Catalogs/>
              </Route>
              {
                state.user && checkAdminRole(state.user) &&
                <Route path={ROUTE_PATHS.fuelCreateUpdate}>
                  <AddFuelCatalog/>
                </Route>
              }
              {
              state.user && fieldSampleAreaEditor(state.user) &&
                <Route path={ROUTE_PATHS.data_process}>
                  <DataProcess/>
                </Route>
              }
              {
                  (state.user?.appRoles) || localStorage.getItem('user')?
                    checkRoutes(state.user, localStorage.getItem('user')): <Redirect to={ROUTE_PATHS.home}/>
              } 
            </Switch>
        </Router>  
    );
}